import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie';


@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    private _client: string;
    private empresa: string;

    constructor(
        @Inject(DOCUMENT) private document: HTMLDocument,
        private httpClient: HttpClient,
        private cookieService: CookieService) { }

    load(){
        this.empresa = this.cookieService.get('idEmpresa');

        return this.httpClient.get('app.config.json')
        .toPromise()
        .then((res:any) => {
			this._client = res.client
            if (this.empresa !== null && this.empresa !== '' && this.empresa !== undefined) {
                this._client = this.cookieService.get('nombreEmpresa').toLowerCase();;

                let theme: HTMLLinkElement = this.document.querySelector('#theme-css');
                theme.href = `assets/theme/${this._client}/theme-light.css`;
            } else {
                let theme: HTMLLinkElement = this.document.querySelector('#theme-css');
                theme.href = `assets/theme/${this.client}/theme-light.css`;
            }
        })
        .catch( e => console.log('Could not load configuration, ', e))
    }

    get client(){
        return this._client
    }
}
